export default __webpack_public_path__ + "static/media/arvr.f316f8a7.png";